module.exports = __webpack_public_path__ + "static/media/project-2.9a687ff6.jpg";